<script setup lang="ts">
import ReviewPlatformsStores from './ReviewSettingsPage/platforms/ReviewPlatformsStores.vue'
import ReviewTemplatesList from './ReviewSettingsPage/templates/ReviewTemplatesList.vue'
import axios from 'axios'
import type { TabKey } from '@/components/base/BaseTab.vue'
import UpsellModuleBanner from '@/components/UpsellModuleBanner.vue'

interface PageTitle {
  title: string
  description?: string
}

const route = useRoute()
const { t } = useI18n()
const { stores } = useLocalStorage()

const isLoaded = ref(false)

const currentTab = ref('platforms')
const tabs = ref<TabKey[]>([
  {
    name: t('pages.review.reviewSettingsPage.tab.platforms'),
    value: 'platforms'
  }
])

const pageTitle: PageTitle = {
  title: 'pages.review.reviewSettingsPage.title'
}

const canSeePartooTemplates = computed(() => {
  return stores.value.some((store: any) => {
    const { storeReviewPlatforms } = store

    // Check if any platform has partoo as review_manager_slug
    return Object.values(storeReviewPlatforms).some((platforms: any) => {
      return Array.isArray(platforms) && platforms.some((platform: any) => platform.review_manager_slug === 'partoo')
    })
  })
})

const fetchReviewPlatforms = async () => {
  try {
    await axios.get('/review-platforms')
  } catch (e) {
    throw new Error(e as string)
  }
}

const refreshStores = async () => {
  const { data } = await axios.get('/stores')
  stores.value = data.data
}

onMounted(async () => {
  await fetchReviewPlatforms()
  isLoaded.value = true

  if (canSeePartooTemplates.value) {
    tabs.value.push({
      name: t('pages.review.reviewSettingsPage.tab.templates'),
      value: 'templates'
    })
  }

  if (route.hash === '#templates') {
    currentTab.value = 'templates'
  }
})
</script>

<template>
  <div>
    <div v-if="isLoaded">
      <div>
        <TheListHeader :title="t(pageTitle.title)" />

        <div class="px-6 pb-6 sm:px-12 sm:pb-12">
          <UpsellModuleBanner />
          <BaseTab v-model="currentTab" :tabs="tabs" class="mb-4" />
          <ReviewPlatformsStores v-if="currentTab === 'platforms'" @change="refreshStores" />
          <ReviewTemplatesList v-if="currentTab === 'templates'" />
        </div>
      </div>
    </div>
    <TheLoadingPage v-else />
  </div>
</template>
